import '../css/app.css';

$(document).ready(function() {

    $(".video").fitVids();

    $('.flexslider').flexslider({
        animation: "slide",
        keyboard: true,
        directionNav: false
        });
        responsiveNav(".nav-collapse", {
            animate: true,
            transition: 200,
            insert: "before",
        });
    });


    $(function(){
        // Turnstile tokens are single use, so the widget has to be re-armed after
        // every submit or a retry (or a second signup) would fail verification.
        function resetTurnstile() {
            if (window.turnstile) {
                window.turnstile.reset('#turnstile-signup');
            }
        }

        $('#form__database').submit( function(ev) {
        ev.preventDefault();
        $( '.errors' ).remove();
        var data = $(this).serialize();
        $.post('/', data, {},'json')
        .done(function(response) {
            $('#form__database')[0].reset();
            resetTurnstile();
            $('#thanks').fadeIn();
          })
          .fail(function(error) {
            resetTurnstile();

            // Guard the shape: a failed Turnstile check, a CSRF failure or a 500
            // may not carry an "errors" object at all.
            var errors = ( error.responseJSON && error.responseJSON.errors ) || {};

            for ( var fieldId in errors ) {
                var $errors = $( '<ul class="errors" />' );
                var messages = $.map(errors[fieldId], function(message) {
                return '<li>' + message + '</li>';
                });
                $errors.append( messages.join( '' ) );
                $('#form__database').after($errors);
            }

          });
    });

    lightbox.option({
        'disableScrolling': true,
        'fadeDuration': 400,
        'imageFadeDuration': 400,
        'resizeDuration': 600,

      })


});





// import "../old/responsive-nav";
// import "../old/jquery.flexslider";
// import "../old/lightbox";
// import "../old/jquery.fitvids";

// import { createApp } from 'vue';

// createApp()
//     .mount('#app');
